import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { StarRating } from 'dibs-elements/exports/StarRating';
import { useSellerRating } from '../hooks/useSellerRating';

// types
import { SharedStarRating_seller$key } from './__generated__/SharedStarRating_seller.graphql';

// styles
import styles from './SharedStarRating.scss';

const sellerFragment = graphql`
    fragment SharedStarRating_seller on Seller {
        ...useSellerRating_seller
    }
`;

export const SharedStarRating: FC<{
    seller: SharedStarRating_seller$key;
    size?: 'small' | 'medium';
}> = ({ seller: sellerRef, size = 'small' }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const feedbackRating = useSellerRating({ seller });

    return (
        <div className={styles.container}>
            {!!feedbackRating && (
                <span className={`${styles.rating} ${styles[size]}`}>
                    <FormattedNumber
                        style="decimal"
                        value={feedbackRating}
                        minimumFractionDigits={1}
                    />
                </span>
            )}
            <StarRating rating={feedbackRating} size="x-small" />
            {!feedbackRating && (
                <span className={`${styles.noReviews} ${styles[size]}`}>
                    <FormattedMessage
                        id="SharedStarRating.noReviews"
                        defaultMessage="No Reviews Yet"
                    />
                </span>
            )}
        </div>
    );
};
